import { defineMessages } from 'react-intl';

const Messages = defineMessages({
  startTrial: {
    id: 'startTrial',
    defaultMessage: 'Start Trial',
  },
  customerName: {
    id: 'customerName',
    defaultMessage: 'Name on Card',
  },
  cardNumber: {
    id: 'cardNumber',
    defaultMessage: 'Card Number',
  },
  expiryDate: {
    id: 'expiryDate',
    defaultMessage: 'Expiration Date',
  },
  month: {
    id: 'month',
    defaultMessage: 'Month',
  },
  year: {
    id: 'year',
    defaultMessage: 'Year',
  },
  expiryYear: {
    id: 'expiryYear',
    defaultMessage: 'Expiration Year',
  },
  securityCode: {
    id: 'securityCode',
    defaultMessage: 'Security Code',
  },
  postalCode: {
    id: 'postalCode',
    defaultMessage: 'Postal Code',
  },
  selectSubscription: {
    id: 'selectSubscription',
    defaultMessage: 'Select Subscription',
  },
  monthly: {
    id: 'monthly',
    defaultMessage: 'Monthly',
  },
  monthlyPremiumDetails: {
    id: 'monthlyPremiumDetails',
    defaultMessage: '60 days free, then {price} + sales tax/month',
  },
  annualPremiumDetails: {
    id: 'annualPremiumDetails',
    defaultMessage: '60 days free, then {price} + sales tax/year',
  },
  trialOfferMonthlyDetails: {
    id: 'trialOfferMonthlyDetails',
    defaultMessage: '{length} days free, then {price} + sales tax/month',
  },
  trialOfferAnnualDetails: {
    id: 'trialOfferAnnualDetails',
    defaultMessage: '{length} days free, then {price} + sales tax/year',
  },
  monthlyDetails: {
    id: 'monthlyDetails',
    defaultMessage: '{price} + sales tax/month',
  },
  monthlyPPDetails: {
    id: 'monthlyPPDetails',
    defaultMessage: '{price} + sales tax/month',
  },
  annual: {
    id: 'annual',
    defaultMessage: 'Annual (Best Value)',
  },
  annualNotBest: {
    id: 'annualNotBest',
    defaultMessage: 'Annual',
  },
  annualDetails: {
    id: 'annualDetails',
    defaultMessage: '{price} + sales tax/year',
  },
  annualPPDetails: {
    id: 'annualPPDetails',
    defaultMessage: '{price} + sales tax/year',
  },
  agreementFirstPart: {
    id: 'agreementFirstPart',
    defaultMessage:
      'I have read and agree to the {extraSubscriptionTerms}{baseSubscriptionTerms}{offerTerms}.{familyAgreement}{trialAgreement}',
  },
  agreementSecondPart: {
    id: 'agreementSecondPart',
    defaultMessage:
      'I agree that this subscription will renew automatically each {frequency} for {offerPrice} + tax until cancelled{studentAgreement}. I understand that (i) I may cancel any time by following {cancelInstructions}, and (ii) cancellation will stop automatic renewal, but my subscription benefits will remain active for the remainder of my current Access Period and I will not receive a refund.',
  },
  agreementCombined: {
    id: 'agreementCombined',
    defaultMessage:
      'I have read and agree to the {extraSubscriptionTerms}{baseSubscriptionTerms}{offerTerms}.{familyAgreement}{trialAgreement} I agree that this subscription will renew automatically each {frequency} for {offerPrice} + tax until cancelled{studentAgreement}. I understand that (i) I may cancel any time by following {cancelInstructions}, and (ii) cancellation will stop automatic renewal, but my subscription benefits will remain active for the remainder of my current Access Period and I will not receive a refund.',
  },
  annualIntroPricingAgreementFirstPart: {
    id: 'annualIntroPricingAgreementFirstPart',
    defaultMessage:
      'I have read and agree to the {subscriptionTerms}{offerTerms}. I understand that{renewDuringTrialAgreement} billing for my {offerTier} subscription will start on {dayAfterExpirationDate} at a rate of {price} + tax/year unless I cancel before that date.',
  },
  annualIntroPricingAgreementSecondPart: {
    id: 'annualIntroPricingAgreementSecondPart',
    defaultMessage:
      'I agree that this subscription will renew automatically each year at the prices shown above until cancelled. I understand that (i) I may cancel any time by following {cancelInstructions}, and (ii) cancellation will stop automatic renewal, but my subscription benefits will remain active for the remainder of my current Access Period and I will not receive a refund.',
  },
  annualIntroPricingAgreementCombined: {
    id: 'annualIntroPricingAgreementCombined',
    defaultMessage:
      'I have read and agree to the {subscriptionTerms}{offerTerms}. I understand that{renewDuringTrialAgreement} billing for my {offerTier} subscription will start on {dayAfterExpirationDate} at a rate of {price} + tax/year unless I cancel before that date. I agree that this subscription will renew automatically each year at the prices shown above until cancelled. I understand that (i) I may cancel any time by following {cancelInstructions}, and (ii) cancellation will stop automatic renewal, but my subscription benefits will remain active for the remainder of my current Access Period and I will not receive a refund.',
  },
  monthlyIntroPricingAgreementFirstPart: {
    id: 'monthlyIntroPricingAgreementFirstPart',
    defaultMessage:
      'I have read and agree to the {subscriptionTerms}{offerTerms}. I understand that billing for my {offerTier} subscription will start today at a rate of {trialPrice} + tax/month for the next {numMonths, plural, one {# month} other {# months}}, and that this price will increase to {price} + tax/month on {dayAfterExpirationDate} unless I cancel before that date.',
  },
  monthlyIntroPricingAgreementSecondPart: {
    id: 'monthlyIntroPricingAgreementSecondPart',
    defaultMessage:
      'I agree that this subscription will renew automatically each month at the prices shown above until cancelled. I understand that (i) I may cancel any time by following {cancelInstructions}, and (ii) cancellation will stop automatic renewal, but my subscription benefits will remain active for the remainder of my current Access Period and I will not receive a refund.',
  },
  monthlyIntroPricingAgreementCombined: {
    id: 'monthlyIntroPricingAgreementCombined',
    defaultMessage:
      'I have read and agree to the {subscriptionTerms}{offerTerms}. I understand that billing for my {offerTier} subscription will start today at a rate of {trialPrice} + tax/month for the next {numMonths, plural, one {# month} other {# months}}, and that this price will increase to {price} + tax/month on {dayAfterExpirationDate} unless I cancel before that date. I agree that this subscription will renew automatically each month at the prices shown above until cancelled. I understand that (i) I may cancel any time by following {cancelInstructions}, and (ii) cancellation will stop automatic renewal, but my subscription benefits will remain active for the remainder of my current Access Period and I will not receive a refund.',
  },
  extraSubscriptionTerms: {
    id: 'extraSubscriptionTerms',
    defaultMessage: '{terms}, ',
  },
  familyAgreement: {
    id: 'familyAgreement',
    defaultMessage:
      ' I confirm that I am at least 21 years old and all family account holders reside at the same address.',
  },
  trialAgreement: {
    id: 'trialAgreement',
    defaultMessage:
      ' I understand that billing will automatically start on {billingStartDate} at a rate of {price} + tax/{frequency} unless I cancel before that date.',
  },
  studentAgreement: {
    id: 'studentAgreement',
    defaultMessage:
      ' and that this price will increase to {price}/{frequency} + tax when my eligibility for the Student Discount ends or I fail to re-verify my eligibility',
  },
  renewDuringTrialAgreement: {
    id: 'renewDuringTrialAgreement',
    defaultMessage: ' I will be billed {priorTierPrice} + tax on {currentRenewalDate}, and',
  },
  studentPlanDenied4Year: {
    id: 'studentPlanDenied4Year',
    defaultMessage:
      "You're no longer eligible for Pandora Premium Student because you've exceeded the maximum allowable 4 years of the discount period.",
  },
  seeOtherPlans: {
    id: 'seeOtherPlans',
    defaultMessage: 'See our other plans.',
  },
  agreementCancel: {
    id: 't.agreementCancel',
    defaultMessage: 'canceled',
  },
  agreementCancelInstructions: {
    id: 'agreementCancelInstructions',
    defaultMessage: 'these instructions',
  },
  termsLink: {
    id: 'termsLink',
    defaultMessage: 'Subscription Terms',
  },
  studentTermsLink: {
    id: 'studentTermsLink',
    defaultMessage: 'Student Discount Terms',
  },
  militaryTermsLink: {
    id: 'militaryTermsLink',
    defaultMessage: 'Military Discount Terms',
  },
  offerTermsLink: {
    id: 'offerTermsLink',
    defaultMessage: 'Offer Terms',
  },
  andOfferTerms: {
    id: 'andOfferTerms',
    defaultMessage: ' and {offerTermsLink}',
  },
  updatingAgreement: {
    id: 'updatingAgreement',
    defaultMessage: 'By continuing, you agree to the {link}.',
  },
  submit: {
    id: 'submit',
    defaultMessage: 'Submit',
  },
  save: {
    id: 'save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
  },
  enterName: {
    id: 'enterName',
    defaultMessage: 'Please enter a name.',
  },
  enterCreditCard: {
    id: 'enterCreditCard',
    defaultMessage: 'Please enter your credit card.',
  },
  selectMonth: {
    id: 'selectMonth',
    defaultMessage: 'Please select an expiration month.',
  },
  selectYear: {
    id: 'selectYear',
    defaultMessage: 'Please select an expiration year.',
  },
  enterSecurityCode: {
    id: 'enterSecurityCode',
    defaultMessage: 'Please enter your security code.',
  },
  enterZipCode: {
    id: 'enterZipCode',
    defaultMessage: 'Please enter your billing zip code.',
  },
  selectFrequency: {
    id: 'selectFrequency',
    defaultMessage: 'Please select your billing frequency.',
  },
  invalidCardNumber: {
    id: 'invalidCardNumber',
    defaultMessage: 'Please enter a valid credit card number.',
  },
  invalidPaymentInformation: {
    id: 'invalidPaymentInformation',
    defaultMessage:
      'Sorry, the payment information is not valid. Please go back and verify your details or choose an alternate payment method.',
  },
  nondescriptError: {
    id: 'nondescriptError',
    defaultMessage: 'Sorry, your payment information is not valid. Please update your details.',
  },
  invalidZipCode: {
    id: 'invalidZipCode',
    defaultMessage: 'Please enter a valid zip code.',
  },
  expiryDateInvalid: {
    id: 'expiryDateInvalid',
    defaultMessage: 'This expiration date is invalid.',
  },
  expiryDateInPast: {
    id: 'expiryDateInPast',
    defaultMessage: 'Please enter a valid expiration date.',
  },
  invalidSecurityCode: {
    id: 'invalidSecurityCode',
    defaultMessage: 'This security code is invalid.',
  },
  subscriptionsNotAvailable: {
    id: 'subscriptionsNotAvailable',
    defaultMessage: 'Subscriptions Not Available',
  },
  notOutsideUS: {
    id: 'notOutsideUS',
    defaultMessage: 'Sorry, new subscriptions are no longer available outside the United States.',
  },
  deleteCreditCard: {
    id: 'deleteCreditCard',
    defaultMessage: 'Delete this card',
  },
  deleteCreditCardInformation: {
    id: 'deleteCreditCardInformation',
    defaultMessage: 'By deleting your credit card, your {planName} subscription will be canceled.',
  },
  insufficientGiftCardBalanceForCCDelete: {
    id: 'insufficientGiftCardBalanceForCCDelete',
    defaultMessage:
      'Also, you only have {giftCardRemainingBalance} remaining on your gift card. ' +
      "If you cancel now the remaining value on your gift card will be lost and you won't be able to use " +
      "the remaining balance on this gift card because it isn't sufficient to pay for the least expensive plan. " +
      'See {pandoraHelpLink} for additional information.',
  },
  areYouSureConfirmation: {
    id: 'areYouSureConfirmation',
    defaultMessage: 'Are you sure?',
  },
  unsentInvitesFamilyPlanConfirmation: {
    id: 'unsentInvitesFamilyPlanConfirmation',
    defaultMessage: 'You still have unsent invites.',
  },
  leaveFamilyPlanInformation: {
    id: 'leaveFamilyPlanInformation',
    defaultMessage:
      "If you remove yourself from this {planName} plan, you'll immediately lose access to your songs, albums, playlists, and downloads.",
  },
  removeFamilyPlanChildInformation: {
    id: 'removeFamilyPlanChildInformation',
    defaultMessage:
      "Removing {emailAddress} means that they'll immediately lose access to their songs, albums, playlists, and downloads.",
  },
  hasUnsentFamilyPlanInviteInformation: {
    id: 'hasUnsentFamilyPlanInviteInformation',
    defaultMessage:
      'Tap the “Invite” button next to each email to invite each person to your Pandora Premium Family plan.',
  },
  keepCard: {
    id: 'keepCard',
    defaultMessage: 'Dismiss',
  },
  deleteCard: {
    id: 'deleteCard',
    defaultMessage: 'Delete card and cancel subscription',
  },
  restoreSubscription: {
    id: 'restoreSubscription',
    defaultMessage: 'Re-subscribe',
  },
  somethingHasGoneWrong: {
    id: 'somethingHasGoneWrong',
    defaultMessage: 'Something has gone wrong. Please try again later.',
  },
  somethingHasGoneWrongRefreshRetry: {
    id: 'somethingHasGoneWrongRefreshRetry',
    defaultMessage:
      'Something went wrong. Try refreshing the page and if the problem continues, please come back and try again later.',
  },
  okay: {
    id: 'okay',
    defaultMessage: 'Okay',
  },
  alreadySubscribedToSamePlan: {
    id: 'alreadySubscribedToSamePlan',
    defaultMessage: "You're already subscribed to {planName}",
  },
  manageSubscriptionOnNativeApp: {
    id: 'manageSubscriptionOnNativeApp',
    defaultMessage: 'Please manage your subscription through the Pandora native app',
  },
  existingPlusPlanCoachmarkError: {
    id: 'existingPlusPlanCoachmarkMemberError',
    defaultMessage: "You're already subscribed to Pandora Plus.",
  },
  invitedToJoinFamilyPlan: {
    id: 'invitedToJoinFamilyPlan',
    defaultMessage: '{emailAddress} has been invited to join your Pandora Premium Family plan.',
  },
  alreadyInvitedToJoinPremiumFamily: {
    id: 'alreadyInvitedToJoinPremiumFamily',
    defaultMessage:
      '{emailAddress} has already been invited to join your Pandora Premium Family plan. Please enter a different email.',
  },
  revokedInviteToFamilyPlan: {
    id: 'revokedInviteToFamilyPlan',
    defaultMessage: 'Your Pandora Premium Family plan invite to {emailAddress} has been canceled.',
  },
  resentInviteToFamilyPlan: {
    id: 'resentInviteToFamilyPlan',
    defaultMessage: 'Your Pandora Premium Family plan invite to {emailAddress}  has been resent.',
  },
  removedChildFamilyPlan: {
    id: 'removedChildFamilyPlan',
    defaultMessage: '{emailAddress} has been removed from your Pandora Premium Family plan.',
  },
  manageFamilyPlan: {
    id: 'manageFamilyPlan',
    defaultMessage: 'Manage Family Plan',
  },
  manageFamilyPlanDescription: {
    id: 'manageFamilyPlanDescription',
    defaultMessage: 'Invite up to 5 people to join your Pandora Premium Family Plan',
  },
  ineligiblePartnerUpgrade: {
    id: 'ineligiblePartnerUpgrade',
    defaultMessage:
      '{listenerEmail} is not eligible for the {planName} upgrade through {partner} because this account is already subscribed to Pandora Plus, Premium, or Premium Family.',
  },
  loginDifferentAccount: {
    id: 'loginDifferentAccount',
    defaultMessage: 'Log in with a different Pandora account',
  },
  createNewAccount: {
    id: 'createNewAccount',
    defaultMessage: 'Sign up for a new Pandora account',
  },
  offerNotAvailable: {
    id: 'offerNotAvailable',
    defaultMessage: 'Offer not available',
  },
  notEligibleWithMoreOptions: {
    id: 'notEligibleWithMoreOptions',
    defaultMessage: "You're not eligible for this {pandoraTier} offer, but you have more options.",
  },
  alreadySubscribed: {
    id: 'alreadySubscribed',
    defaultMessage:
      "You are not eligible for a trial, you're already subscribed to Pandora {pandoraTier}.",
  },
  seeOffer: {
    id: 'showOffer',
    defaultMessage: 'See my offer',
  },
  canceledNotification: {
    id: 'canceledNotification',
    defaultMessage: 'Your {planName} subscription has been canceled.',
  },
  subscribedNotification: {
    id: 'subscribedNotification',
    defaultMessage: 'Congratulations, your {planName} subscription is now active.',
  },
  subscriptionHasBeenUpdated: {
    id: 'subscriptionHasBeenUpdated',
    defaultMessage: 'Your subscription has been updated.',
  },
  changesSaved: {
    id: 'changesSaved',
    defaultMessage: 'Your changes have been saved.',
  },
  subscribedPromoNotification: {
    id: 'subscribedPromoNotification',
    defaultMessage: 'Congratulations, your {planName} trial subscription is now active.',
  },
  giftContinuation: {
    id: 'giftContinuation',
    defaultMessage:
      "Congratulations, you'll continue to enjoy {planName} even after this gift subscription ends.",
  },
  expiredSubscriberNotification: {
    id: 'expiredSubscriberNotification',
    defaultMessage: 'Your subscription has expired. Click {hereLink} to renew.',
  },
  here: {
    id: 'here',
    defaultMessage: 'here',
  },
  expiredPremiumSubscriberNotificationTitle: {
    id: 'expiredPremiumSubscriberNotificationTitle',
    defaultMessage: 'Your Pandora Premium subscription has expired.',
  },
  expiredPremiumSubscriberNotificationBody: {
    id: 'expiredPremiumSubscriberNotificationBody',
    defaultMessage:
      'All the stations you’ve created are still here. Albums, songs, and playlists you’ve enjoyed in Pandora Premium will be waiting for you when you {resubscribeLink}.',
  },
  expiredPremiumSubscriberReSubscribe: {
    id: 'expiredPremiumSubscriberReSubscribe',
    defaultMessage: 're-subscribe',
  },
  notNow: {
    id: 'notNow',
    defaultMessage: 'Not Now',
  },
  subscribedGiftHoursNotification: {
    id: 'subscribedGiftHoursNotification',
    defaultMessage:
      'Congratulations, your {duration}-hour {pandoraTier} subscription is now active.',
  },
  close: {
    id: 'close',
    defaultMessage: 'Close',
  },
  giftDaysRemaining: {
    id: 'giftDaysRemaining',
    defaultMessage: `{daysLeft, plural,
      one {# day}
      other {# days}
    } remaining of your free gift`,
  },
  doNotWantPremium: {
    id: 'doNotWantPremium',
    defaultMessage: "Don't want Pandora Premium?",
  },
  pandoraPlusMonthly: {
    id: 'pandoraPlusMonthly',
    defaultMessage: '$4.99/month',
  },
  pandoraPlusMonthlyLegacy: {
    id: 'pandoraPlusMonthlyLegacy',
    defaultMessage: '$3.99/month',
  },
  pandoraPlusAnnualLegacy: {
    id: 'pandoraPlusAnnualLegacy',
    defaultMessage: '$47.88/year',
  },
  pandoraPlusAnnual: {
    id: 'pandoraPlusAnnual',
    defaultMessage: '$54.89/year',
  },
  pandoraPremiumMonthly: {
    id: 'pandoraPremiumMonthly',
    defaultMessage: '$9.99/month',
  },
  pandoraPremiumAnnual: {
    id: 'pandoraPremiumAnnual',
    defaultMessage: '$109.89/year',
  },
  pandoraFamilyMonthly: {
    id: 'pandoraFamilyMonthly',
    defaultMessage: '$14.99/month',
  },
  pandoraFamilyAnnual: {
    id: 'pandoraFamilyAnnual',
    defaultMessage: '$164.89/year',
  },
  premiumMonthly6MonthExplanation: {
    id: 'premiumMonthly6MonthExplanation',
    defaultMessage:
      'Your Pandora Premium subscription period will start today and will automatically renew at {price} per month for six months, unless you cancel. See email receipt for details.',
  },
  premiumTrial60: {
    id: 'premiumTrial60',
    defaultMessage: 'Get 60 days of Pandora Premium for free.',
  },
  premiumTrial6MonthsAnnual: {
    id: 'premiumTrial6MonthsAnnual',
    defaultMessage:
      'Get {trialDisplayableDuration} at no additional cost to your current plan, then pay {displayablePrice} / {frequencyForDurationType}.',
  },
  premiumBenefit1: {
    id: 'premiumBenefit1',
    defaultMessage: 'Search and play millions of albums and songs',
  },
  premiumBenefit2: {
    id: 'premiumBenefit2',
    defaultMessage: 'Create playlists, on your own or powered by Pandora',
  },
  premiumBenefit3: {
    id: 'premiumBenefit3',
    defaultMessage: 'Download the music you love to listen offline',
  },
  premiumBenefit4: {
    id: 'premiumBenefit4',
    defaultMessage: 'Listen without ad interruptions',
  },
  enterPaymentDetails: {
    id: 'enterPaymentDetails',
    defaultMessage: 'Enter your payment details below.',
  },
  price: {
    id: 'price',
    description: 'cost per month',
    defaultMessage: '{price} {currency} a month',
  },
  annualPlan: {
    id: 'annualPlan',
    defaultMessage: 'or save with an annual plan',
  },
  defaultDisclaimer: {
    id: 'defaultDisclaimer',
    defaultMessage:
      'Skips limited by certain licensing restrictions. Subscription automatically renews after trial or current Access Period unless {cancel} in advance.  {subscriptionTerms} and {offerTerms} apply.',
  },
  familyDisclaimer: {
    id: 't.familyDisclaimer',
    defaultMessage:
      'Skips limited by certain licensing restrictions. Master account holder must be 21+; all account holders must reside at same address. Subscription automatically renews after trial or current Access Period unless {cancel} in advance.  {subscriptionTerms} and {offerTerms} apply.',
  },
  studentDisclaimer: {
    id: 't.studentDisclaimer',
    defaultMessage:
      'Skips limited by certain licensing restrictions. U.S. residents, 18+, enrolled at accredited higher education institutions in the U.S. only. Requires annual eligibility verification. Subscription automatically renews after trial or current Access Period unless {cancel} in advance. {subscriptionTerms} and {offerTerms} apply.',
  },
  militaryDisclaimer: {
    id: 't.militaryDisclaimer',
    defaultMessage:
      'Skips limited by certain licensing restrictions. Offer open to U.S. residents, 18+, active duty in any branch of the U.S. military, plus retirees, veterans, national guard, reserves, and dependents. Requires eligibility verification. Subscription automatically renews after trial or current Access Period unless {cancel} in advance. {subscriptionTerms} and {offerTerms} apply.',
  },
  trialOffersLink: {
    id: 'trialOffersLink',
    defaultMessage: 'Offer Terms',
  },
  flexExclusions: {
    id: 'flexExclusions',
    defaultMessage:
      'Skips and replays may be limited by certain licensing restrictions. Some advertising exclusions apply.',
  },
  exclusions: {
    id: 'exclusions',
    defaultMessage: ' See {link} for details.',
  },
  subscriptionTerms: {
    id: 'subscriptionTerms',
    defaultMessage: 'Subscription Terms',
  },
  startFreeTrial: {
    id: 'startFreeTrial',
    defaultMessage: 'Start Free Trial',
  },
  upgrade: {
    id: 'upgrade',
    defaultMessage: 'Upgrade',
  },
  upgradeNow: {
    id: 'upgradeNow',
    defaultMessage: 'Upgrade Now',
  },
  login: {
    id: 'login',
    defaultMessage: 'Log in',
  },
  signup: {
    id: 'signup',
    defaultMessage: 'Sign Up',
  },
  giveGift: {
    id: 'gift',
    defaultMessage: 'Give Pandora Plus as a gift',
  },
  viewTerms: {
    id: 'viewTerms',
    defaultMessage: 'View Terms and Conditions',
  },
  business: {
    id: 'business',
    defaultMessage: 'Find out how you can play Pandora at your business. ',
  },
  businessLink: {
    id: 'businessLink',
    defaultMessage: 'Learn More',
  },
  creditCard: {
    id: 'creditCard',
    defaultMessage: 'Credit Card',
  },
  paypal: {
    id: 'paypal',
    defaultMessage: 'PayPal',
  },
  freeTrial: {
    id: 'freeTrial',
    defaultMessage: '7 free days of Pandora Plus',
  },
  renewNow: {
    id: 'renewNow',
    defaultMessage: 'Renew Now',
  },
  autoRenew: {
    id: 'autoRenew',
    defaultMessage:
      "Your {planName} subscription will automatically renew on {date}. You'll be charged {price} + tax/{timeUnit} unless you cancel your subscription.",
  },
  sixMonthTrialBanner: {
    id: 'sixMonthTrialBanner',
    defaultMessage: 'Your 6 months of {planName} at no additional cost trial ends {date}.',
  },
  paidMonthTrialBanner: {
    id: 'paidMonthTrialBanner',
    defaultMessage: 'Your {planName} for {price} / month trial ends on {date}.',
  },
  paidOnceOffTrialBanner: {
    id: 'paidOnceOffTrialBanner',
    defaultMessage: 'Your {planName} for {price} trial ends on {date}.',
  },
  sixMonthAnnualPreRenewalDateOne: {
    id: 'sixMonthAnnualPreRenewalDateOne',
    defaultMessage: 'On {date} your subscription will be renewed at {price} + tax.',
  },
  sixMonthAnnualPreRenewalDateTwo: {
    id: 'sixMonthAnnualPreRenewalDateTwo',
    defaultMessage:
      'At the end of your trial, {date}, you will be charged {price} + tax for your first year of Pandora Premium, less a prorated credit for the unused portion of your Plus subscription. You may cancel your subscription at any time.',
  },
  trialEndsSoon: {
    id: 'trialEndsSoon',
    defaultMessage: 'Your {planName} free trial ends on {date}.',
  },
  giftCardLowBalance: {
    id: 'giftCardLowBalance',
    defaultMessage:
      'If your gift card balance is not enough to cover the renewal amount, the remaining balance ' +
      'on your card will be used after which you will have the option to enter a new payment method to continue your subscription.',
  },
  giftSubscription: {
    id: 'giftSubscription',
    defaultMessage: 'Your {planName} gift subscription ends on {date}.',
  },
  giftSubscriptionWithPendingTrial: {
    id: 'giftSubscriptionWithPendingTrial',
    defaultMessage: 'Your {planName} gift subscription and trial end on {date}.',
  },
  downgradeMessage: {
    id: 'downgradeMessage',
    defaultMessage:
      "Your {planName} features will expire on {date} and your subscription will automatically renew on {date} for {nextPlanName}. You'll be charged {price} + sales tax per {timeUnit} unless you cancel your subscription.",
  },
  gifteeUpsell: {
    id: 'gifteeUpsell',
    defaultMessage:
      "Don't lose your {planName} experience! It’s only {price} + tax per {timeUnit}. Add your payment info below to keep the music playing.",
  },
  keepSubscriptionAddPaymentInfo: {
    id: 'keepSubscriptionAddPaymentInfo',
    defaultMessage:
      "Don't lose your {planName} experience! It’s only {price} + tax per {timeUnit}. Add your payment info below.",
  },
  hiddenCard: {
    id: 'hiddenCard',
    defaultMessage: '{cardType} - {lastFourDigits}',
  },
  complimentaryBannerText: {
    id: 'complimentaryBannerText',
    defaultMessage: 'Your complimentary subscription of {planName} ends on {date}.',
  },
  complimentaryInfoText: {
    id: 'complimentaryInfoText',
    defaultMessage:
      'Are you enjoying Pandora Plus? Add or verify your payment information below to keep the ad-free music playing — for only $4.99 a month.',
  },
  paymentDetails: {
    id: 'paymentDetails',
    defaultMessage: 'Subscription Details',
  },
  vendorManage: {
    id: 'vendorManage',
    defaultMessage:
      "You're currently subscribed to {planName} via {vendor}. Manage your subscription on {vendorHelpLink}.",
  },
  unableToSubscribeToPlanHeadline: {
    id: 'unableToSubscribeToPlanHeadline',
    defaultMessage: 'Unable to subscribe to {planName}.',
  },
  vendorUnavailable: {
    id: 'vendorUnavailable',
    defaultMessage:
      "You're currently subscribed to {activePlanName} via {vendor}. The {upgradePlanName} Plan isn't currently available through {vendor}.",
  },
  vendorUnavailableInstructionsHeader: {
    id: 'vendorUnavailableInstructionsHeader',
    defaultMessage: 'To Get {planName}:',
  },
  vendorUnavailableInstructionsItem1: {
    id: 'vendorUnavailableInstructionsItem1',
    defaultMessage: 'Cancel your {planName} subscription through {vendor}. {cancelLink}',
  },
  vendorUnavailableInstructionsSubItem1: {
    id: 'vendorUnavailableInstructionsSubItem1',
    defaultMessage: 'Learn more about canceling your subscription.',
  },
  vendorUnavailableInstructionsItem2: {
    id: 'vendorUnavailableInstructionsItem2',
    defaultMessage: 'Wait for your subscription to expire. {premiumText}',
  },
  vendorUnavailableInstructionsSubItem2: {
    id: 'vendorUnavailableInstructionsSubItem2',
    defaultMessage:
      'Albums, songs, and playlists you’ve enjoyed in Pandora Premium will be waiting for you when you re-subscribe.',
  },
  vendorUnavailableInstructionsItem3: {
    id: 'vendorUnavailableInstructionsItem3',
    defaultMessage: "Re-subscribe on pandora.com – we'll send you a reminder!",
  },
  underAgeFPBody: {
    id: 'underAgeFPBody',
    defaultMessage: 'You must be 21 years or older to start a Pandora Premium Family plan.',
  },
  underAgeFPSubBody: {
    id: 'underAgeFPSubBody',
    defaultMessage:
      'To join, have someone else in your family who is 21 years or older start a Pandora Premium Family plan, then they can add you to the plan as a family member.',
  },
  underAgeFPSubText: {
    id: 'underAgeFPSubText',
    defaultMessage: 'Alternatively, see other subscription plans.',
  },
  upgradeVendorPremium: {
    id: 'upgradeVendorPremium',
    defaultMessage:
      "You're currently subscribed to Pandora Plus through {vendor}. Go to your Pandora {os} app to upgrade to Pandora Premium.",
  },
  vendorBilledInstructions: {
    id: 'vendorBilledInstructions',
    defaultMessage:
      "You're currently subscribed to {planName} via {vendor}. {upgradePlanName} currently isn't available through the {vendor} store. To get {upgradePlanName}, cancel your {planName} subscription via {vendor}, wait for it to expire, then re-subscribe on pandora.com",
  },
  upgradeVia3rdParty: {
    id: 'upgradeVia3rdParty',
    defaultMessage:
      "You're currently subscribed to {planName} through {thirdParty}. Go to {thirdPartyRef} to upgrade to {upgradePlanName}.",
  },
  paymentInfo: {
    id: 'paymentInfo',
    defaultMessage: 'Payment Info',
  },
  updatePaymentDetails: {
    id: 'updatePaymentDetails',
    defaultMessage: 'Update',
  },
  updatePayment: {
    id: 'updatePayment',
    defaultMessage: 'Update Payment Info',
  },
  addPaymentInfo: {
    id: 'addPaymentInfo',
    defaultMessage: 'Add Payment Info',
  },
  cancelSubscription: {
    id: 'cancelSubscription',
    defaultMessage: 'Cancel Subscription',
  },
  plusTax: {
    id: 'plusTax',
    defaultMessage: '+ sales tax',
  },
  pleaseAddPaymentInfoAndResubscribe: {
    id: 'pleaseAddPaymentInfoAndResubscribe',
    defaultMessage:
      'Your subscription will automatically end unless you add your payment info and re-subscribe.',
  },
  subscriptionEnd: {
    id: 'subscriptionEnd',
    defaultMessage:
      "Don't lose your {planName} experience! Add your payment info below or your subscription will automatically end on {date}.",
  },
  pleaseResubscribe: {
    id: 'pleaseResubscribe',
    defaultMessage: 'Your subscription will automatically end unless you re-subscribe.',
  },
  expiringSubscription: {
    id: 'expiringSubscription',
    defaultMessage: 'Your access to {planName} will end on {date}.',
  },
  expiringSubscriptionPleaseResubscribe: {
    id: 'expiringSubscriptionPleaseResubscribe',
    defaultMessage:
      'Your {planName} subscription will automatically end on {date}, unless you re-subscribe.',
  },
  familyManagementMenuInvite: {
    id: 'familyManagementMenuInvite',
    defaultMessage: 'Invite',
  },
  familyManagementMenuDone: {
    id: 'familyManagementMenuDone',
    defaultMessage: 'Done',
  },
  familyManagementMenuSkipForNow: {
    id: 'familyManagementMenuSkipForNow',
    defaultMessage: 'Skip For Now',
  },
  familyManagementMenuRevokeInvite: {
    id: 'familyManagementMenuRevokeInvite',
    defaultMessage: 'Cancel Invite',
  },
  familyManagementMenuResendInvite: {
    id: 'familyManagementMenuResendInvite',
    defaultMessage: 'Resend Invite',
  },
  familyManagementMenuRemoveFromPlan: {
    id: 'familyManagementMenuRemoveFromPlan',
    defaultMessage: 'Remove From Plan',
  },
  next: {
    id: 'next',
    defaultMessage: 'Next',
  },
  currentPlan: {
    id: 'currentPlan',
    defaultMessage: 'Current Plan',
  },
  managedBy: {
    id: 'managedBy',
    defaultMessage: 'Managed by {email}',
  },
  pandoraPlanWithPrice: {
    id: 'pandoraPlanWithPrice',
    defaultMessage: '{price} / {frequency}',
  },
  switchPlans: {
    id: 'switchPlans',
    defaultMessage: 'Switch Plan',
  },
  getPremium: {
    id: 'getPremium',
    defaultMessage: 'Get Premium',
  },
  manageFamily: {
    id: 'manageFamily',
    defaultMessage: 'Manage Family',
  },
  leaveFamily: {
    id: 'leaveFamily',
    defaultMessage: 'Leave Family Plan',
  },
  selectAPlan: {
    id: 'selectAPlan',
    defaultMessage: 'Select a Plan',
  },
  reSubscribe: {
    id: 'reSubscribe',
    defaultMessage: 'Re-subscribe',
  },
  onlyAvailableInUS: {
    id: 'onlyAvailableInUS',
    defaultMessage: 'Sorry, Pandora Premium is currently only available in the United States.',
  },
  giftCodeUsed: {
    id: 'giftCodeUsed',
    defaultMessage: 'Sorry. This Pandora Premium invite has already been used.',
  },
  notEligibleSubHeader: {
    id: 'notEligibleSubHeader',
    defaultMessage:
      'But stay tuned! Pandora Premium should be made available for you soon, and we’ll be sure to let you know when it is.',
  },
  newWindowLink: {
    id: 'newWindowLink',
    defaultMessage: 'Opens new window',
  },
  premiumLink: {
    id: 'premiumLink',
    defaultMessage: 'pandora.com/premium',
  },
  invalidSubheader: {
    id: 'invalidSubheader',
    defaultMessage:
      'Otherwise, stay tuned!  Pandora Premium should be available without an invite soon, and we’ll be sure to let you know when it is.',
  },
  goToMyMusic: {
    id: 'goToMyMusic',
    defaultMessage: 'Go to My Music',
  },
  subscription: {
    id: 'subscription',
    defaultMessage: 'Subscription',
  },
  planNotAvailable: {
    id: 'planNotAvailable',
    defaultMessage:
      "Sorry, as a current {planName} subscriber, you're not eligible for this offer.",
  },
  genericPlanNotAvailable: {
    id: 'genericPlanNotAvailable',
    defaultMessage: 'Sorry. {planName} isn’t available for this account.',
  },
  specialOfferPlanNotAvailable: {
    id: 'specialOfferPlanNotAvailable',
    defaultMessage: 'Sorry. The {planName} offer isn’t available for this account.',
  },
  signUpAnonText: {
    id: 'signUpAnonText',
    defaultMessage: 'Sign up to start listening for free.',
  },
  signUpAnonButtonText: {
    id: 'signUpAnonButtonText',
    defaultMessage: 'Sign Up Now',
  },
  cancelGift: {
    id: 'cancelGift',
    defaultMessage: 'Cancel Gift',
  },
  areYouSure: {
    id: 'areYouSure',
    defaultMessage: 'Are you sure?',
  },
  yesImSure: {
    id: 'yesImSure',
    defaultMessage: "Yes, I'm sure",
  },
  loseAccessToPremium: {
    id: 'loseAccessToPremium',
    defaultMessage:
      'You’ll lose access to your songs, albums, playlists, and downloads until you subscribe.',
  },
  dismiss: {
    id: 'dismiss',
    defaultMessage: 'Dismiss',
  },
  continue: {
    id: 'continue',
    defaultMessage: 'Continue',
  },
  active: {
    id: 'active',
    defaultMessage: 'Active',
  },
  invitePending: {
    id: 'invitePending',
    defaultMessage: 'Invite Pending',
  },
  email: {
    id: 'email',
    defaultMessage: 'Email',
  },
  emailAddress: {
    id: 'emailAddress',
    defaultMessage: 'Email Address',
  },
  startListening: {
    id: 't.startListening',
    defaultMessage: 'Start Listening',
  },
  welcomeHeader: {
    id: 't.welcomeHeader',
    defaultMessage: 'Welcome to',
  },
  student: {
    id: 't.student',
    defaultMessage: 'student',
  },
  military: {
    id: 't.military',
    defaultMessage: 'military',
  },
  cancelAnytime: {
    id: 't.cancelAnytime',
    defaultMessage: 'Cancel anytime.',
  },
  free: {
    id: 'free',
    defaultMessage: 'Free',
  },
  getFreeTrial: {
    id: 't.freeTrialOffer',
    defaultMessage: 'Get {trialDisplayableDuration} of {planName} for free.',
  },
  trialOfferNextStep: {
    id: 't.trialOfferNextStep',
    defaultMessage:
      'After that, pay only {displayablePrice} per {frequencyForDurationType}. Cancel anytime.',
  },
  getDefaultOffer: {
    id: 't.nonTrialOffer',
    defaultMessage:
      'Get {planName} for only {displayablePrice}/{frequencyForDurationType}. Cancel anytime.',
  },
  studentReverificationBannerText: {
    id: 't.studentReverificationBannerText',
    defaultMessage:
      'Your Premium Student discount expires on {date}. {verifyLink} to extend your discount by another year.',
  },
  reverifyNow: {
    id: 't.reverifyNow',
    defaultMessage: 'Reverify now',
  },
  studentPlanDenied4YearPendingBannerText: {
    id: 'studentPlanDenied4YearPendingBannerText',
    defaultMessage:
      'After the maximum four years of eligibility, your Premium Student discount will expire on {date} and your subscription will be automatically converted to the regular priced Premium plan.',
  },
  studentReverificationRenewalInfoText: {
    id: 't.studentReverificationRenewalInfoText',
    defaultMessage:
      "The Student Discount requires annual eligibility re-verification in order to maintain the discount. If you don't reverify in time, your plan will automatically convert to the regular priced Premium plan and you will be charged {undiscountedPrice} + tax/{timeUnit}.",
  },
  insufficientGiftCardBalanceForCCUpdate: {
    id: 'insufficientGiftCardBalanceForCCUpdate',
    defaultMessage:
      'You only have {giftCardRemainingBalance} remaining on your gift card. ' +
      'If you remove your gift card now the remaining value on your gift card will be lost and you ' +
      "won't be able to use the remaining balance on this gift card because it isn't sufficient " +
      'to pay for the least expensive plan. See {pandoraHelpLink} for additional information.',
  },
  blackhawkServerErrorUpgradeLinkTitle: {
    id: 'blackhawkServerErrorUpgradeLinkTitle',
    defaultMessage: 'Pandora Select Lower Cost Plan',
  },
});

export default Messages;
